import { compact } from 'lodash';
import {
  GET_CONVERSATION_DETAIL_SUCCESS,
  LOAD_SUCCESS,
  PushEventEnum,
  UPDATE_CONVERSATION_SUCCESS,
} from '../utils/constants';

export const conversationReducer = (state, action) => {
  const {
    type,
    payload: { conversations, conversation },
  } = action;

  switch (type) {
    case LOAD_SUCCESS:
      return {
        ...state,
        conversationLoading: false,
        conversations,
      };

    case GET_CONVERSATION_DETAIL_SUCCESS:
      if (
        state?.conversation?.items?.length > 0 &&
        conversation?.items?.length > 0
      ) {
        const stateMessageIds = state?.conversation?.items?.map(
          (item) => item?.id
        );
        const idExisted = conversation?.items?.find((item) =>
          stateMessageIds?.includes(item?.id)
        );
        if (idExisted) return state;
      }
      return {
        ...state,
        conversationLoading: false,
        conversation:
          state?.conversation?.items?.length > 0
            ? conversation?.items[0]?.conversationId ===
              state?.conversation?.items[0]?.conversationId
              ? {
                  ...state?.conversation,
                  items: [
                    ...state?.conversation?.items,
                    ...conversation?.items,
                  ],
                  pagination: Object.assign({}, conversation?.pagination),
                }
              : conversation
            : conversation,
      };

    case UPDATE_CONVERSATION_SUCCESS:
      return {
        ...state,
        conversationLoading: false,
        conversations: state?.conversations?.map((conversationItem) => {
          return conversationItem?.id === action?.payload?.conversation?.id
            ? {
                ...action?.payload?.conversation,
                messages: [action?.payload?.message],
              }
            : conversationItem;
        }),
        conversation: state?.conversation
          ? state?.conversation?.items[0]?.conversationId ===
            action?.payload?.conversation?.id
            ? {
                ...state?.conversation,
                items: [
                  action?.payload?.message,
                  ...state?.conversation?.items,
                ],
              }
            : state?.conversation
          : null,
      };

    case PushEventEnum.CONVERSATION_GROUP_LEFT:
      return {
        ...state,
        conversationLoading: false,
        conversations: compact(
          state?.conversations?.map((conversationItem) =>
            conversationItem?.id === action?.payload?.conversation?.id
              ? action?.payload?.userId === action?.payload?.authUserId
                ? null
                : action?.payload?.conversation
              : conversationItem
          )
        ),
        conversation: state?.conversation
          ? state?.conversation?.items[0]?.conversationId ===
            action?.payload?.conversation?.id
            ? action?.payload?.userId === action?.payload?.authUserId
              ? null
              : {
                  ...state?.conversation,
                  items: [
                    action?.payload?.conversation?.messages[0],
                    ...state?.conversation?.items,
                  ],
                }
            : state?.conversation
          : null,
      };

    case PushEventEnum.CONVERSATION_GROUP_JOINED:
      return {
        ...state,
        conversationLoading: false,
        conversations: action?.payload?.userIds?.includes(
          action?.payload?.authUserId
        )
          ? [action?.payload?.conversation, ...state?.conversations]
          : state?.conversations?.map((conversationItem) =>
              conversationItem?.id === action?.payload?.conversation?.id
                ? action?.payload?.conversation
                : conversationItem
            ),
        conversation: state?.conversation
          ? state?.conversation?.items[0]?.conversationId ===
            action?.payload?.conversation?.id
            ? action?.payload?.userId === action?.payload?.authUserId
              ? null
              : {
                  ...state?.conversation,
                  items: [
                    action?.payload?.conversation?.messages[0],
                    ...state?.conversation?.items,
                  ],
                }
            : state?.conversation
          : null,
      };

    case PushEventEnum.NEW_MESSAGE:
      if (
        state?.conversation?.items?.length > 0 &&
        conversation?.items?.length > 0
      ) {
        const stateMessageIds = state?.conversation?.items?.map(
          (item) => item?.id
        );
        const idExisted = conversation?.items?.find((item) =>
          stateMessageIds?.includes(item?.id)
        );
        if (idExisted) return state;
      }
      return {
        ...state,
        conversationLoading: false,
        conversation:
          state?.conversation?.items?.length > 0
            ? state?.conversation?.items[0]?.conversationId ===
              action?.payload?.message?.conversationId
              ? {
                  ...state?.conversation,
                  items: [
                    action?.payload?.message,
                    ...state?.conversation?.items,
                  ],
                }
              : state?.conversation
            : null,
        conversations: state?.conversations?.map((conversationItem) => {
          return conversationItem?.id === action?.payload?.conversation?.id
            ? {
                ...action?.payload?.conversation,
                messages: [action?.payload?.message],
              }
            : conversationItem;
        }),
      };

    case PushEventEnum.NEW_CONVERSATION:
      const stateConversationIds = state?.conversations?.map(
        (item) => item?.id
      );
      const idExisted = stateConversationIds?.includes(
        action?.payload?.conversation?.id
      );
      if (idExisted) return state;
      return {
        ...state,
        conversationLoading: false,
        conversations: [action?.payload?.conversation, ...state?.conversations],
      };

    case PushEventEnum.MESSAGE_SEEN:
      if (
        state?.conversation?.items?.length > 0 &&
        conversation?.items?.length > 0
      ) {
        const stateMessageIds = state?.conversation?.items?.map(
          (item) => item?.id
        );
        const idExisted = conversation?.items?.find((item) =>
          stateMessageIds?.includes(item?.id)
        );
        if (idExisted) return state;
      }
      return {
        ...state,
        conversationLoading: false,
        conversation:
          state?.conversation?.items?.length > 0
            ? action.payload.messages[0]?.conversationId ===
              state?.conversation?.items[0]?.conversationId
              ? {
                  ...state?.conversation,
                  items: state?.conversation?.items?.map((message) => {
                    const messageExisted = action?.payload?.messages?.find(
                      (subMessage) => subMessage?.id === message?.id
                    );
                    if (messageExisted) {
                      return messageExisted;
                    }
                    return message;
                  }),
                }
              : conversation
            : conversation,
      };

    default:
      return state;
  }
};
